import { useEffect, useMemo, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { showAlert } from 'actions/app';
import { getBulkSequencesRecommendedDays } from 'services/bulkEmail';
import { BulkDrawerFormFieldsMap } from 'UI/components/organisms/BulkEmailForm/fields';
import { getOrdinalSuffix } from 'UI/utils';

export const useGetTriggerDays = () => {
  const dispatch = useDispatch();
  const [triggerDays, setTriggerDays] = useState(null);

  const { watch } = useFormContext();
  const scopeWatcher = watch(BulkDrawerFormFieldsMap.BulkScope.key);

  const triggerDaysByType = useMemo(() => {
    if (scopeWatcher && triggerDays) {
      const days = triggerDays[scopeWatcher.title].DayDelayByAttempt;
      const mappedDays = {};

      Object.keys(days).forEach(key => {
        const ordinalSuffix = getOrdinalSuffix(key);
        mappedDays[ordinalSuffix] = days[key];
      });

      return mappedDays;
    }
    return null;
  }, [scopeWatcher, triggerDays]);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      const { success, alert, data } = await getBulkSequencesRecommendedDays();
      if (!isMounted) return;

      if (success) {
        setTriggerDays(data);
      } else {
        dispatch(showAlert(alert));
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [dispatch]);

  return { triggerDaysByType };
};
